module.exports = ("1.9.5");


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/version.js
// module id = 52
// module chunks = 0